import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { getNavItemForProductLine, getSegmentedNavItems } from '../utils/routingUtils';
import { transformState } from './SelectorUtils';
export const navItemForProductLineSelector = createSelectorFromUtil(getNavItemForProductLine, transformState);
export const segmentedNavItemsSelector = createSelectorFromUtil(getSegmentedNavItems, transformState);